module.exports = __webpack_public_path__ + "static/media/about-1.1d3a42ce.jpg";